import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from 'cccisd-modal';
import Tooltip from 'cccisd-tooltip';
import Table from 'cccisd-table';
import _uniqBy from 'lodash/uniqBy';

const FilterItself = props => {
    const { assessments, initialValues, onSubmit, closeModal } = props;
    const selected = useRef(() => new Set(initialValues.map(item => item.id)));
    const [selectedRows] = useState(() => initialValues.map(item => item.id.toString()));

    const columns = [
        {
            name: 'assessments',
            label: 'Assigned Assessments',
            render: (_, row) => (
                <ul className="ps-4 mb-0">
                    {row.assessments.map(item => (
                        <li key={item.id}>{item.label}</li>
                    ))}
                </ul>
            ),
        },
        {
            name: 'reporters',
            label: 'Reporters',
            render: (_, row) => (
                <ul className="ps-4 mb-0">
                    {_uniqBy(row.assessments, item => item.reporter).map(item => (
                        <li key={item.id}>{item.reporter}</li>
                    ))}
                </ul>
            ),
        },
        { name: 'assessedAt', label: 'Date Assessed', render: value => value.slice(0, 10) },
        {
            name: 'archived',
            label: 'Archived',
            class: 'text-center',
            render: value => (value ? 'Yes' : 'No'),
            filter: true,
            filterSettings: {
                type: 'selectbox',
                options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                ],
                custom: (row, filterValue) => {
                    const isArchived = filterValue === true || filterValue === 'true';
                    return isArchived ? row.archived : !row.archived;
                },
            },
        },
    ];

    return (
        <div>
            <Table
                data={assessments}
                columns={columns}
                showPerPageOptions={false}
                hideShowingRowsSummary
                isSimpleCheckboxes
                selectedRows={selectedRows}
                className="table table-sm table-bordered"
                rowSelectedCallback={ids => {
                    selected.current = new Set(ids.map(Number));
                }}
            />
            <div className="mt-3">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                        closeModal();
                        onSubmit(assessments.filter(item => selected.current.has(item.id)));
                    }}
                >
                    Submit
                </button>
            </div>
        </div>
    );
};

const AssessmentFilter = props => {
    const { initialValues } = props;

    return (
        <Modal
            trigger={
                <Tooltip
                    title={`Filter by assessment and/or archive status. Assessments currently selected: ${initialValues.length}`}
                >
                    <button type="button" className="btn btn-secondary btn-sm">
                        Assessment Filter
                    </button>
                </Tooltip>
            }
            title="Pick Assessments"
            size="calc(100vw - 4rem)"
            render={({ closeModal }) => <FilterItself {...props} closeModal={closeModal} />}
        />
    );
};

AssessmentFilter.propTypes = {
    assessments: PropTypes.array,
    initialValues: PropTypes.array,
    onSubmit: PropTypes.func,
};

AssessmentFilter.defaultProps = {
    initialValues: [],
};

export default AssessmentFilter;
